import React from 'react';
import C from '../styles/tokens';

// ─── SVG ICONS ────────────────────────────────────────────────────────────────
export const HomeIcon = ({ color, size }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none"
    stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z"/>
    <polyline points="9 22 9 12 15 12 15 22"/>
  </svg>
);

export const BuyIcon = ({ color, size }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none"
    stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10"/>
    <line x1="12" y1="8" x2="12" y2="16"/>
    <line x1="8" y1="12" x2="16" y2="12"/>
  </svg>
);

export const WithdrawIcon = ({ color, size }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none"
    stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="12" y1="5" x2="12" y2="19"/>
    <polyline points="19 12 12 19 5 12"/>
  </svg>
);

export const AccountIcon = ({ color, size }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none"
    stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2"/>
    <circle cx="12" cy="7" r="4"/>
  </svg>
);

export const CheckIcon = ({ color = '#fff', size = 14, strokeWidth = 3 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none"
    stroke={color} strokeWidth={strokeWidth} strokeLinecap="round">
    <polyline points="20 6 9 17 4 12"/>
  </svg>
);

export const ArrowLeftIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none"
    stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="15 18 9 12 15 6"/>
  </svg>
);

export const ArrowRightIcon = ({ color = '#94a3b8', size = 16 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none"
    stroke={color} strokeWidth="2">
    <polyline points="9 18 15 12 9 6"/>
  </svg>
);

export const ExternalLinkIcon = ({ size = 14 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none"
    stroke="currentColor" strokeWidth="2">
    <path d="M18 13v6a2 2 0 01-2 2H5a2 2 0 01-2-2V8a2 2 0 012-2h6"/>
    <polyline points="15 3 21 3 21 9"/>
    <line x1="10" y1="14" x2="21" y2="3"/>
  </svg>
);

export const UploadIcon = ({ size = 16 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none"
    stroke="currentColor" strokeWidth="2">
    <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4"/>
    <polyline points="17 8 12 3 7 8"/>
    <line x1="12" y1="3" x2="12" y2="15"/>
  </svg>
);

export const ClockIcon = ({ color, size = 16 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none"
    stroke={color || C.warning} strokeWidth="2">
    <circle cx="12" cy="12" r="10"/>
    <polyline points="12 6 12 12 16 14"/>
  </svg>
);

export const ShieldIcon = ({ size = 16 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none"
    stroke={C.accent} strokeWidth="2">
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
  </svg>
);

export const MessageIcon = ({ size = 18 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none"
    stroke={C.primary} strokeWidth="2">
    <path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z"/>
  </svg>
);

export const InfoIcon = ({ color, size = 16 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none"
    stroke={color || C.primary} strokeWidth="2">
    <circle cx="12" cy="12" r="10"/>
    <polyline points="12 6 12 12 16 14"/>
  </svg>
);

export const AlertCircleIcon = ({ size = 14 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none"
    stroke={C.danger} strokeWidth="2">
    <circle cx="12" cy="12" r="10"/>
    <line x1="12" y1="8" x2="12" y2="12"/>
    <line x1="12" y1="16" x2="12.01" y2="16"/>
  </svg>
);

export const BellIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2">
    <path d="M18 8A6 6 0 006 8c0 7-3 9-3 9h18s-3-2-3-9"/>
    <path d="M13.73 21a2 2 0 01-3.46 0"/>
  </svg>
);

export const CopyIcon = ({ size = 16 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none"
    stroke="currentColor" strokeWidth="2">
    <rect x="9" y="9" width="13" height="13" rx="2"/>
    <path d="M5 15H4a2 2 0 01-2-2V4a2 2 0 012-2h9a2 2 0 012 2v1"/>
  </svg>
);

export const LockIcon = ({ size = 14 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none"
    stroke="currentColor" strokeWidth="2">
    <rect x="3" y="11" width="18" height="11" rx="2"/>
    <path d="M7 11V7a5 5 0 0110 0v4"/>
  </svg>
);

export const StarIcon = ({ size = 16 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none"
    stroke={C.primary} strokeWidth="2">
    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
  </svg>
);

export const SignOutIcon = ({ size = 14 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none"
    stroke="currentColor" strokeWidth="2">
    <path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4"/>
    <polyline points="16 17 21 12 16 7"/>
    <line x1="21" y1="12" x2="9" y2="12"/>
  </svg>
);

export const TronzaxLogo = ({ size = 18, color = C.primary }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill={color}>
    <circle cx="12" cy="12" r="10"/>
    <path fill="#fff" d="M8 12l2.5 2.5L16 9"/>
  </svg>
);

// ─── BADGE ─────────────────────────────────────────────────────────────────────
export const Badge = ({ children, color = C.primary, bg }) => (
  <span style={{
    background: bg || `${color}18`,
    color,
    borderRadius: 20,
    padding: '3px 10px',
    fontSize: 11,
    fontWeight: 700,
    letterSpacing: '0.3px',
    display: 'inline-block',
  }}>
    {children}
  </span>
);

// ─── CARD ──────────────────────────────────────────────────────────────────────
export const Card = ({ children, style = {}, className = '' }) => (
  <div className={`card ${className}`} style={style}>
    {children}
  </div>
);

// ─── DIVIDER ───────────────────────────────────────────────────────────────────
export const Divider = ({ label }) => (
  <div className="divider-wrap" style={{
    display: 'flex', alignItems: 'center', gap: 10, margin: '4px 0',
  }}>
    <div className="divider" style={{ flex: 1 }} />
    {label && <span style={{ color: C.textMuted, fontSize: 11, fontWeight: 600 }}>{label}</span>}
    {label && <div className="divider" style={{ flex: 1 }} />}
  </div>
);

// ─── BUTTON ────────────────────────────────────────────────────────────────────
export const Btn = ({ children, onClick, variant = 'primary', full = false, size = 'md', disabled = false, icon, style: extraStyle = {} }) => {
  const variants = {
    primary:   'btn-primary',
    secondary: 'btn-secondary',
    outline:   'btn-outline',
    ghost:     'btn-ghost',
    danger:    'btn-danger',
    success:   'btn-success',
  };
  const sizes = {
    sm: 'btn-sm',
    md: 'btn-md',
    lg: 'btn-lg',
  };
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={`btn ${variants[variant]} ${sizes[size]} ${full ? 'btn-full' : ''}`}
      style={extraStyle}
    >
      {icon && icon}
      {children}
    </button>
  );
};

// ─── STEPPER ───────────────────────────────────────────────────────────────────
export const Stepper = ({ steps }) => (
  <div className="stepper">
    {steps.map((step, i) => (
      <div key={i} className="step-row">
        <div className="step-connector-col">
          <div className={`step-dot step-dot-${step.status}`}>
            {step.status === 'done' ? (
              <CheckIcon strokeWidth={3} />
            ) : step.status === 'active' ? (
              <div style={{ width: 10, height: 10, borderRadius: '50%', background: '#fff' }} />
            ) : (
              <div style={{ width: 10, height: 10, borderRadius: '50%', background: C.textMuted }} />
            )}
          </div>
          {i < steps.length - 1 && (
            <div className={`step-line step-line-${step.status === 'done' ? 'done' : 'pending'}`} />
          )}
        </div>
        <div className="step-content" style={{ paddingBottom: i < steps.length - 1 ? 16 : 0 }}>
          <div className={`step-label step-label-${step.status === 'pending' ? 'pending' : 'active'}`}>
            {step.label}
          </div>
          {step.time && <div className="step-time">{step.time}</div>}
        </div>
      </div>
    ))}
  </div>
);

// ─── HEADER ────────────────────────────────────────────────────────────────────
export const Header = ({ title, onBack, rightEl }) => (
  <div className="page-header">
    {onBack ? (
      <button className="header-back-btn" onClick={onBack}>
        <ArrowLeftIcon />
      </button>
    ) : (
      <div style={{ width: 38 }} />
    )}

    <div style={{ flex: 1, textAlign: 'center' }}>
      <div className="flex items-center justify-center gap-8">
        <div className="header-logo-icon">
          <TronzaxLogo />
        </div>
        <span style={{ color: '#fff', fontWeight: 800, fontSize: 18, letterSpacing: '-0.3px' }}>
          Tronzax
        </span>
      </div>
      {title && (
        <div style={{ color: 'rgba(255,255,255,0.85)', fontSize: 13, marginTop: 2 }}>
          {title}
        </div>
      )}
    </div>

    <div style={{ width: 38, display: 'flex', justifyContent: 'flex-end' }}>
      {rightEl}
    </div>
  </div>
);

// ─── BOTTOM NAV ────────────────────────────────────────────────────────────────
export const BottomNav = ({ active, navigate }) => {
  const items = [
    { id: 'dashboard', label: 'Dashboard', Icon: HomeIcon },
    { id: 'buy',       label: 'Buy',       Icon: BuyIcon },
    { id: 'withdraw',  label: 'Withdraw',  Icon: WithdrawIcon },
    { id: 'account',   label: 'Account',   Icon: AccountIcon },
  ];

  return (
    <div className="bottom-nav">
      {items.map(({ id, label, Icon }) => {
        const isActive = active === id;
        return (
          <button key={id} className="nav-item" onClick={() => navigate(id)}>
            <div className={`nav-icon-wrap ${isActive ? 'active' : 'inactive'}`}>
              <Icon color={isActive ? C.primary : C.textMuted} size={20} />
            </div>
            <span className={`nav-label ${isActive ? 'active' : 'inactive'}`}>
              {label}
            </span>
          </button>
        );
      })}
    </div>
  );
};
